import { DeliveryPartner, DeliveryPartnerForm } from './';

export const deliveryPartnerRoutes = [
  {
    path: 'delivery-partners',
    protected: true,
    element: DeliveryPartner,
    roles: [
      'DELIVERY_PARTNER_VIEW',
      'DELIVERY_PARTNER_EDIT',
    ],
  },
  {
    path: 'delivery-partners/delivery-partner-details',
    protected: true,
    element: DeliveryPartnerForm,
    roles: [
      'DELIVERY_PARTNER_EDIT',
      'DELIVERY_PARTNER_VIEW',
    ],
  },
];
